// ABOUTME: Configuration for the Software Environments page tabs.
// ABOUTME: Defines the tab structure for the customer environment picker.

import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';

export const softwareEnvironmentsConfig = {
    customers: {
        title: 'customers',
        icon: <ApartmentOutlinedIcon />,
    },
};
